var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 12.5422C16.75 12.9564 16.4142 13.2922 16 13.2922C15.5858 13.2922 15.25 12.9564 15.25 12.5422C15.25 12.128 15.5858 11.7922 16 11.7922C16.4142 11.7922 16.75 12.128 16.75 12.5422Z",
    fill: "#8E97A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.2922C16.4142 14.2922 16.75 14.628 16.75 15.0422V19.5422C16.75 19.9564 16.4142 20.2922 16 20.2922C15.5858 20.2922 15.25 19.9564 15.25 19.5422V15.0422C15.25 14.628 15.5858 14.2922 16 14.2922Z",
    fill: "#8E97A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 16.0422C24 20.4605 20.4183 24.0422 16 24.0422C11.5817 24.0422 8 20.4605 8 16.0422C8 11.624 11.5817 8.04224 16 8.04224C20.4183 8.04224 24 11.624 24 16.0422ZM22.5 16.0422C22.5 19.6321 19.5899 22.5422 16 22.5422C12.4101 22.5422 9.5 19.6321 9.5 16.0422C9.5 12.4524 12.4101 9.54224 16 9.54224C19.5899 9.54224 22.5 12.4524 22.5 16.0422Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.f89a32dd94557bc4ecfc8f61ff62ba49.svg";
export { ForwardRef as ReactComponent };